import React from 'react';
import Box from '@mui/material/Box';
import {SvgProps} from '../../helpers/type';

const Debts = ({className, sx}: SvgProps): JSX.Element => {
    return (
        <Box
            component="svg"
            viewBox="0 0 65 65"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
            sx={sx}
        >
            <rect x="0.999756" y="0.756592" width="63" height="63" rx="31.5" fill="#E8EDEC" />
            <rect x="0.999756" y="0.756592" width="63" height="63" rx="31.5" stroke="#B9C8C7" />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M37.8559 29.6316H44.9953C44.9983 30.0527 44.9984 30.5166 44.9984 31.0316V33.4816C44.9984 33.484 44.9984 33.4864 44.9984 33.4889C44.9984 33.6636 44.9988 33.8326 44.9991 33.9959C44.9998 34.3111 45.0004 34.6055 44.9984 34.8816H37.8559C36.3767 34.8816 35.1775 33.7063 35.1775 32.2566C35.1775 30.8068 36.3767 29.6316 37.8559 29.6316ZM38.7488 31.3816H37.8559C37.3629 31.3816 36.9631 31.7733 36.9631 32.2566C36.9631 32.7398 37.3629 33.1316 37.8559 33.1316H38.7488C39.2418 33.1316 39.6416 32.7398 39.6416 32.2566C39.6416 31.7733 39.2418 31.3816 38.7488 31.3816Z"
                fill="#3A645F"
                fillOpacity="0.6"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M39.1257 21.831C40.0742 21.907 40.8663 22.0647 41.586 22.4242C42.762 23.0114 43.7181 23.9484 44.3172 25.1009C44.684 25.8063 44.845 26.5826 44.9225 27.5121C44.9324 27.6314 44.9411 27.7545 44.9486 27.8816H43.2097H37.8559C35.3905 27.8816 33.3919 29.8403 33.3919 32.2566C33.3919 34.6728 35.3905 36.6316 37.8559 36.6316H42.32H43.2128H44.9486C44.9411 36.7587 44.9324 36.8817 44.9225 37.001C44.845 37.9306 44.684 38.7069 44.3172 39.4123C43.7181 40.5648 42.762 41.5018 41.586 42.089C40.8663 42.4484 40.0742 42.6062 39.1257 42.6822C38.196 42.7566 37.0408 42.7566 35.5743 42.7566H30.3323C28.8511 42.7566 27.479 42.7566 26.3333 42.6832C25.2126 42.6114 24.1632 42.4641 23.4121 42.089C22.2362 41.5018 21.2801 40.5648 20.6809 39.4123C20.3142 38.7069 20.1532 37.9306 20.0757 37.001C19.9997 36.0899 19.9998 34.9577 19.9998 33.5205V30.9927C19.9998 29.5555 19.9997 28.4233 20.0757 27.5121C20.1532 26.5826 20.3142 25.8063 20.6809 25.1009C21.2801 23.9484 22.2362 23.0114 23.4121 22.4242C24.1632 22.0491 25.2126 21.9018 26.3333 21.83C27.479 21.7566 28.851 21.7566 30.3323 21.7566L35.5743 21.7566C37.0408 21.7566 38.196 21.7566 39.1257 21.831ZM25.3566 26.1316H30.7135C31.2066 26.1316 31.6063 26.5233 31.6063 27.0066C31.6063 27.4898 31.2066 27.8816 30.7135 27.8816H25.3566C24.8635 27.8816 24.4638 27.4898 24.4638 27.0066C24.4638 26.5233 24.8635 26.1316 25.3566 26.1316Z"
                fill="#3A645F"
                fillOpacity="0.6"
            />
        </Box>
    );
};

export default Debts;
